angular.module('tgaApp').config(['$locationProvider', '$stateProvider', '$urlRouterProvider',
  function ($locationProvider, $stateProvider, $urlRouterProvider) {
    // AngularUI Router uses the concept of states
    // Learn more here: https://github.com/angular-ui/ui-router
    // Set up the various states which the app can be in.
    // Each state's controller can be found in controllers.js
    $stateProvider
      // setup an abstract state for the main view that includes tabs
      .state('game', {
        url: '/:slug',
        templateUrl: 'views/startup.html',
        data: {
          title: 'Scenarios - The Training Arcade®',
        },
      });

    // if none of the above states are matched, use this as the fallback
    $urlRouterProvider.otherwise('/');
    $locationProvider.html5Mode(true);
  }]);
